import { ComponentQrcodePainsItems, Maybe } from '@/typings/types';
import SlideUp from '@/common/utils/slideUp';

type ProductsProps = {
  items: Maybe<ComponentQrcodePainsItems[] | undefined>;
};

const ProductsList = ({ items }: ProductsProps) => {
  const Products = items?.map((item) => {
    const { id, name, price } = item ?? {};
    const priceFixed = price?.toFixed(2);
    const priceWithComma = priceFixed?.toString().replace('.', ',');
    return (
      name && (
        <SlideUp key={id} yOffset={25} delay delayDuration={150}>
          <dl className={'flex flex-row flex-wrap items-start justify-start'}>
            <dt className={'text-lg font-normal tracking-wider font-stigsaMedium'}>
              {name}&nbsp;{priceWithComma && '•'}&nbsp;
            </dt>
            <dd className={'lg:w-3/12 font-bold leading-[24px] text-base font-libertineRegular'}>
              {priceWithComma}&nbsp;{priceWithComma && '€'}
            </dd>
          </dl>
        </SlideUp>
      )
    );
  });
  return <div className={'flex flex-col'}>{Products}</div>;
};

export default ProductsList;
